export default __webpack_public_path__ + "static/media/AU.5a05d8f5.svg";